import getSymbolFromCurrency from "currency-symbol-map";

import { store } from "../index";

export default function getCurrency() {
  const orgDetails = store.getState().getProfileDetails;
  return getSymbolFromCurrency(orgDetails?.currency?.currency_code);
}
